import { request as requester } from 'sonata-react-components';

import type { SharedReport } from 'sonata-static-storage/lib/schemas/report/sharedReport.schema';
import type { SessionInterface } from 'sonata-static-storage/lib/schemas/session/session.schema';

export type CreatedSharedReportSession = (SessionInterface & { success?: true }) | { success: false; message: string };

export async function createSharedReportSession(
  sharedReportId: string,
  password?: string
): Promise<CreatedSharedReportSession> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}session/sharedReport`, {
    data: {
      password,
      sharedReportId
    },
    method: 'POST'
  });
}

export async function getSharedReportSession(
  sharedReportId: string,
  sessionInfo: SessionInterface | null
): Promise<SharedReport<string>> {
  return requester.makeRequest(`${taptap.config.backendUrlBase}report/sharedReport/${sharedReportId}?populate=true`, {
    headers: { ...sessionInfo },
    method: 'GET'
  });
}
